<template>
  <div ref="tempref" class="absolute bottom-[35px] right-[75px] bg-g0 flex flex-col p-4 z-50 shadow-2xl w-[300px]">
    <div class="flex flex-row justify-between pb-2 items-center">
      <h3 class="font-bold mr-5">
        {{ $e("Cartes") }}
      </h3>

      <router-link :to="{ name: 'CustomMap_Add' }"
        @click.stop="close"
        :title="$e('Ajouter une carte personnalisée')"
        class="h-full flex "
      >
        <svg class="fill-current cursor-pointer" width="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75">
          <rect width="75" height="15" transform="translate(0 30)"></rect>
          <rect width="75" height="15" transform="translate(44.5) rotate(90)"></rect>
        </svg>
      </router-link>
    </div>

    <div class="flex flex-wrap  pb-2">
      <div v-for="(item, key) in lstMaps" :key="'basemapImagery' + key" style="margin-top:5px;">
        <div
          class="bg-g2 py-1 mr-2 px-3 text-xs text-center rounded-full transition-all cursor-pointer peer-checked:bg-flyingeye hover:bg-flyingeye-light flex items-center"
          @click.stop.prevent="changeFondDeCarte(key)"
          :class="keyMapSelected === key ? ' imagerymapBtnSelected ' : ' '">
          <input class="hidden peer " type="radio" name="imagerylayer_choice" :id="'itemImageryLayer_' + key"
            :checked="keyMapSelected === key" />
          <label :for="'itemImageryLayer_' + key">{{ item.displayname }}</label>

          <router-link
            :to="{ name: 'CustomMap_Edit', params: { map_key: key } }"
            @click.stop="close"
            :title="$e('Modifier la carte')"
          >
            <div :id="'itemImageryLayer_Edit_' + key" class="cursor-pointer iconsManageCustomImagery"
              :class="item.isCustom !== null && item.isCustom !== '' && item.isCustom ? '' : 'hidden'">
              <div class="w-[20px] fill-current" v-html="$root.svg_form_path.edit"></div>
            </div>
          </router-link>

          <div
            class="cursor-pointer iconsManageCustomImagery"
            :class="item.isCustom !== null && item.isCustom !== '' && item.isCustom ? '' : 'hidden'"
            :title="$e('Supprimer carte')"
            :id="'itemImageryLayer_Delete_' + key"
            @click.stop="deleteCustomMap(key)"
          >
            <div class="w-[20px] fill-current" v-html="$root.svg_form_path.delete"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Map from "@/utils/Map";
import User from '@/utils/User';
import { getServerConfig } from "@/utils/serverConfig";

export default {
  name: "Map_FondDeCarte",
  setup() {
    return {
      lstMaps: ref(null),
      keyMapSelected: ref(Map.imagery.imageryKeySelected),
      customMaps: ref({}),


      clickevent: ref(null),
      tempref: ref(null),
    };
  },

  async mounted() {
    const serverConfig = await getServerConfig();
    this.customMaps = $root.user.getSettingsCustomMap();
    this.lstMaps = serverConfig.basemap;
    if (Object.keys(this.customMaps).length > 0) {
      this.lstMaps = Object.assign({}, this.lstMaps, this.customMaps);
    }

    this.clickevent = document.addEventListener("click", (e) => {
      if (e.target == this.tempref) return;

      let parrent = e.target.parentElement;
      for (let i = 0; i < 100; i++) {
        if (parrent == this.tempref) return;
        if (parrent == undefined) i = 100;
        parrent = parrent?.parentElement;
      }

      this.$emit("close");
    })
  },

  unmounted() {
    document.removeEventListener("click", this.clickevent)
  },

  methods: {
    close() {
      this.$emit("close");
    },

    changeFondDeCarte(keymap) {
      if (this.keyMapSelected !== keymap) {
        this.keyMapSelected = keymap;
        Map.imagery.changeFondDeCarte(keymap);
      }
    },

    deleteCustomMap(key) {
      this.$root.confirm_open({
        message: this.$e("Etes-vous sûr de vouloir supprimer la carte personnalisée :") +"'" + this.lstMaps[key].displayname + "' ?",
        true: async () => {
          // Suppression ImageryProvider cible
          Map.imagery.deleteImageryProvider(key);
          // Mise à jour du localStorage
          $root.user.removeItemCustomMap(key);

          // Fermer la fenêtre
          this.close();
        },
        false: () => { },
      });
    },
  }
};
</script>
